<template>
  <v-snackbar
    :type="notification.type"
    :icon="notification.icon"
    v-model="notificationValue"
    top
    :timeout="15000"
    color="white"
    class="notification"
  >
    <v-icon :color="notification.type">{{ icon }}</v-icon>
    <p class="secondary--text">
      <span class="title">{{ notification.title }}</span>
      <span v-html="notification.text"></span>
    </p>
    <v-icon @click="notificationValue = false">mdi-close-circle-outline</v-icon>
  </v-snackbar>
</template>

<script>
export default {
  name: "Notification",
  data: () => ({
    timeoutId: null,
    defaultIcons: {
      info: "mdi-information",
      success: "mdi-check",
      warning: "mdi-exclamation",
      error: "mdi-alert"
    }
  }),
  props: {
    notification: {
      type: Object
    }
  },
  computed: {
    notificationValue: {
      get() {
        return this.notification.value;
      },
      set(value) {
        if (value === false) {
          this.$store.dispatch("notificationStore/hideNotification", {
            ...this.notification
          });
        }
      }
    },
    icon() {
      if (this.notification) {
        return (
          this.notification.icon ||
          this.defaultIcons[this.notification.type] ||
          ""
        );
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  flex: 1 1;
  margin: 0 16px;
}
.notification {
  align-items: baseline;
  position: relative;
  margin-bottom: 10px;
  min-width: 300px;
  top: 0;
  left: 0;
}
</style>
